import { ReportsItem } from "common/interface/interface"

import CardItem from "../CardItem"
import EmptyYet from "../Empty"
import Style from "./index.module.scss"

interface CardListItemsProps {
	items: ReportsItem[]
	locale: string
}

export default function CardListItems({ items, locale }: CardListItemsProps) {
	if (!items?.length) {
		return <EmptyYet />
	}

	return (
		<div className={Style.grid}>
			{items.map((card) => (
				<CardItem key={card.id} info={card} locale={locale} />
			))}
		</div>
	)
}
